// src/api/backtest.js
// API utility for the WG backtest engine

export async function runBacktest(payload) {
  const requestPayload = {
    ...payload,
    auto_fetch_benchmark: payload?.auto_fetch_benchmark ?? true,
  };
  const response = await fetch("/backtest/run", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestPayload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.detail || "Backtest run failed");
  }
  return response.json();
}

export async function getBacktestMetrics(equityRows) {
  const response = await fetch("/backtest/metrics", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ equity_rows: equityRows }),
  });
  if (!response.ok) throw new Error("Backtest metrics failed");
  return response.json();
}

export async function compareBacktest(payload) {
  const response = await fetch("/backtest/compare", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error("Backtest comparison failed");
  return response.json();
}

export async function runWalkForward(payload) {
  const requestPayload = {
    ...payload,
    auto_fetch_benchmark: payload?.auto_fetch_benchmark ?? true,
  };
  const response = await fetch("/backtest/walk-forward", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(requestPayload),
  });
  if (!response.ok) throw new Error("Walk-forward analysis failed");
  return response.json();
}
